import { gql, useQuery, QueryHookOptions } from '@apollo/client';

export const query = gql`
  query HiveUser($hiveId: ID!, $userId: ID!) {
    hiveUser(hiveId: $hiveId, userId: $userId) {
      id
      firstName
      lastName
      userName
      password
      points
      numberOfGames
      totalTime
      allowedHiveGames
    }
  }
`;

export interface RequestType {
  hiveId: string;
  userId: string;
}

export interface HiveUserType {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  userName: string;
  password?: string | null;
  points?: number | null;
  numberOfGames?: number | null;
  totalTime?: number | null;
  allowedHiveGames?: string[] | null;
}

export interface QueryType {
  hiveUser: HiveUserType;
}

export function useHiveUserQuery(
  request: RequestType,
  options?: QueryHookOptions<QueryType, RequestType>,
) {
  return useQuery<QueryType, RequestType>(query, {
    variables: request,
    ...options,
  });
}
